<template>
  <div class="alignment">
    <v-flex xs12>
      <h3 class="styleHeader">
        {{ $t("pages.Order.Create.InserimentoOrdine") }}
      </h3>
      <v-card class="styleDataTable">
        <customerComponent
          v-on:customerChange="custChanged"
          ref="customerComponent"
        ></customerComponent>
      </v-card>
    </v-flex>
    <v-layout>
      <!--prima colonna-->
      <v-flex xs12 sm6 sm4 class="styleAlignementElementsCardRight">
        <h4 class="styleHeader styleHeaderTop">
          {{ $t("pages.Order.Create.DatiTestata") }}
        </h4>
        <v-card class="styleDataTable">
          <template>
            <v-form>
              <v-text-field
                v-model="orderNumber"
                :label="$t('pages.Order.Create.NumeroOrdine')"
                required
                :rules="[rules.max12]"
                :error-messages="orderNumberErrors"
                @blur="$v.orderNumber.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="refOrderClient"
                :label="$t('pages.Order.Create.RiferimentoOrdine')"
                required
              ></v-text-field>
              <v-flex xs12 sm12 md12>
                <v-menu
                  v-model="modal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateClientOrder"
                      :label="$t('pages.Order.Create.DataOrdine')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateClientOrder"
                    color="#279947"
                    @input="modal = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-menu
                  v-model="modal2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="deliveryDate"
                      :label="$t('pages.Order.Create.DataConsegna')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="deliveryDate"
                    color="#279947"
                    @input="modal2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-text-field
                v-model="destinationCompanyName"
                :label="$t('pages.Order.Create.RagioneSocialeDestinazione')"
                required
                :error-messages="destinationCompanyNameErrors"
                @blur="$v.destinationCompanyName.$touch()"
                :rules="[rules.max50]"
              ></v-text-field>
              <v-text-field
                v-model="destinationAddress"
                :label="$t('pages.Order.Create.IndirizzoDestinazione')"
                required
                :error-messages="destinationAddressErrors"
                @blur="$v.destinationAddress.$touch()"
                :rules="[rules.max50]"
              ></v-text-field>
              <v-text-field
                v-model="destinationCAP"
                :label="$t('pages.Order.Create.CAPDestinazione')"
                required
                :error-messages="destinationCAPErrors"
                @blur="$v.destinationCAP.$touch()"
                :rules="[rules.max10]"
              ></v-text-field>
              <v-text-field
                v-model="destinationLocation"
                :label="$t('pages.Order.Create.LocalitaDestinazione')"
                required
                :error-messages="destinationLocationErrors"
                @blur="$v.destinationLocation.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="destinationProvince"
                :label="$t('pages.Order.Create.ProvinciaDestinazione')"
                required
                :error-messages="destinationProvinceErrors"
                @blur="$v.destinationProvince.$touch()"
                :rules="[rules.max2]"
              ></v-text-field>
              <v-select
                v-model="destiationNation"
                :label="$t('pages.Order.Create.NazioneDestinazione')"
                required
                autocomplete
                :items="nations"
                item-value="codnaz"
                item-text="descr"
              ></v-select>
              <v-select
                v-model="orderType"
                :label="$t('pages.Order.Create.TipoOrdine')"
                required
                :items="orders"
                item-text="descr"
                item-value="tipoordine"
              ></v-select>
              <v-text-field
                v-model="mark"
                :label="$t('pages.Order.Create.Contrassegno')"
                required
                :rules="[rules.decimal]"
              ></v-text-field>
              <v-select
                v-model="port"
                :label="$t('pages.Order.Create.Porto')"
                required
                :items="ports"
                item-text="descr"
                item-value="codporto"
              ></v-select>
              <v-select
                v-model="causalTrasnport"
                :label="$t('pages.Order.Create.CausaleTrasporto')"
                required
                :items="casuals"
                item-text="descr"
                item-value="codtrasporto"
              ></v-select>
              <v-select
                v-model="carrier"
                :label="$t('pages.Order.Create.Vettore')"
                required
                :items="carriers"
                item-text="descr"
                item-value="codvettore"
              ></v-select>
              <v-text-field
                v-model="clientEmail"
                :label="$t('pages.Order.Create.EmailCliente')"
                required
              ></v-text-field>
              <v-text-field v-model="note" label="Note"></v-text-field>
            </v-form>
          </template>
        </v-card>
      </v-flex>

      <!--seconda colonna-->
      <v-flex xs12 sm6 sm4>
        <h4 class="styleHeader styleHeaderTop">{{$t('pages.Order.Create.DatiCliente')}}</h4>
        <v-card class="styleDataTable">
       <v-select
              v-model="customer"
              :items="customers"
              :label="$t('pages.Order.Create.Cliente')"
              autocomplete
              required
              item-text="ragsoc"
              item-value="codcli"
              @input.native="OnChangeClient($event)"
              @change="checkAutoFill()"
              :error-messages="CustomerError"
              @blur="$v.customer.$touch()"
        ></v-select>
          <template>
            <v-form>
              <v-switch
                color="#279947"
                v-model="useData"
                :label="$t('pages.Order.Create.UsaDatiAnagraficaDestinazione')"
                @change="autocompleteClient(useData)"
              ></v-switch>
              <v-text-field
                v-model="codeCustomer"
                :label="$t('pages.Order.Create.CodiceCliente')"
                required
                :disabled="edit"
                @blur="$v.codeCustomer.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="businessNameCustomer"
                :label="$t('pages.Order.Create.RagSocCliente')"
                required
                :disabled="edit"
                @blur="$v.businessNameCustomer.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="clientAddress"
                :label="$t('pages.Order.Create.indirizzo')"
                required
                :disabled="edit"
                @blur="$v.clientAddress.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="clientCAP"
                :label="$t('pages.Order.Create.CAP')"
                required
                :disabled="edit"
                @blur="$v.clientCAP.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="clientPlace"
                :label="$t('pages.Order.Create.Località')"
                required
                :disabled="edit"
                @blur="$v.clientPlace.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="clientProvince"
                :label="$t('pages.Order.Create.Provincia')"
                required
                :disabled="edit"
                @blur="$v.clientProvince.$touch()"
              ></v-text-field>
              <v-select
                v-model="clientNation"
                :label="$t('pages.Order.Create.Nazione')"
                required
                :disabled="edit"
                item-value="codnaz"
                item-text="descr"
                @blur="$v.clientNation.$touch()"
              ></v-select>
              <v-btn
                v-if="btnAddUser"
                @click="viewCreate(true)"
                class="white--text styleAlignementSaveButton"
                color="#279947"
              >
                <v-icon left>add</v-icon>
                {{ $t("pages.Order.Create.NuovoCliente") }}
              </v-btn>
              <v-btn
                v-if="btnCancelAddUser"
                @click="hideCreate(false)"
                class="styleAlignementSaveButton"
              >
                <v-icon left>remove_circle</v-icon>
                {{ $t("pages.Order.Create.Annulla") }}
              </v-btn>
            </v-form>
          </template>
        </v-card>
      </v-flex>

      <!--terza colonna-->
      <v-flex
        xs12
        sm6
        sm4
        class="styleAlignementElementsCardLeft"
        v-if="addUser"
      >
        <h4 class="styleHeader styleHeaderTop">
          {{ $t("pages.Order.Create.DatiNuovoCliente") }}
        </h4>
        <v-card class="styleDataTable">
          <template>
            <v-form>
              <v-text-field
                v-model="newCodeCustomer"
                :label="$t('pages.Order.Create.CodiceCliente')"
                required
                :rules="[rules.max12]"
                :error-messages="newCodeCustomerError"
                @blur="$v.newCodeCustomer.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="newBusinessNameCustomer"
                :label="$t('pages.Order.Create.RagSocCliente')"
                required
                :error-messages="newBusinessNameCustomerError"
                @blur="$v.newBusinessNameCustomer.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="newClientAddress"
                :label="$t('pages.Order.Create.Indirizzo')"
                required
                :error-messages="newClientAddressError"
                @blur="$v.newClientAddress.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="newClientCAP"
                :label="$t('pages.Order.Create.CAP')"
                required
                :error-messages="newClientCAPError"
                @blur="$v.newClientCAP.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="newClientPlace"
                :label="$t('pages.Order.Create.Località')"
                required
                :error-messages="newClientPlaceError"
                @blur="$v.newClientPlace.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="newClientProvince"
                :label="$t('pages.Order.Create.Provincia')"
                required
                :error-messages="newClientProvinceError"
                @blur="$v.newClientProvince.$touch()"
              ></v-text-field>
              <v-select
                v-model="newClientNation"
                :label="$t('pages.Order.Create.Nazione')"
                required
                :items="Newnations"
                :error-messages="newClientNationError"
                item-value="codnaz"
                item-text="descr"
                @blur="$v.newClientNation.$touch()"
              ></v-select>
              <v-switch
                color="#279947"
                v-model="newUseData"
                :label="$t('pages.Order.Create.UsaDatiAnagraficaDestinazione')"
                @change="autocompleteNewClient(newUseData)"
              ></v-switch>
            </v-form>
          </template>
        </v-card>
      </v-flex>
    </v-layout>

    <!--Dati righe ordine-->
    <v-layout>
      <v-flex xs12>
        <div>
          <v-toolbar
            flat
            style="background-color:#fafafa; margin-top: 10px; margin-left:-24px; height=82px;"
          >
            <h4 class="styleHeader styleHeaderTop pa-0">{{$t('pages.Order.Create.DatiRigheOrdine')}}</h4>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="80%">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="#279947"
                  class="right white--text styleHeader styleAlignamentAddButton"
                  style="margin-right:-48px;"
                  v-on="on"
                >
                  <v-icon left>add</v-icon>
                  {{ $t("pages.Order.Create.Aggiungi") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="padding-left: 0px">{{
                    formTitle
                  }}</span>
                </v-card-title>

                <v-card-text style="padding -16px">
                  <v-container grid-list-md>
                    <v-layout>
                      <v-flex xs12 sm6 md4>
                        <v-select
                          v-model="articleCode"
                          :label="$t('pages.Order.Create.CodiceArticolo')"
                          required
                          autocomplete
                          :items="articles"
                          :error-messages="articleCodeError"
                          item-value="codart"
                          item-text="codart"
                          @input="$v.articleCode.$touch()"
                          @blur="$v.articleCode.$touch()"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-select
                          v-model="articleCode"
                          :label="$t('pages.Order.Create.Descrizione')"
                          required
                          autocomplete
                          :items="articles"
                          :error-messages="articleCodeError"
                          item-value="codart"
                          item-text="descr"
                          @input="$v.articleCode.$touch()"
                          @blur="$v.articleCode.$touch()"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="qta"
                          :label="$t('pages.Order.Create.Qta')"
                          type="number"
                          :rules="[rules.digits]"
                          required
                          :error-messages="qtaError"
                          @input="$v.qta.$touch()"
                          @blur="$v.qta.$touch()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.site"
                          :label="$t('pages.Order.Create.Lotto')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.reserveCode"
                          :label="$t('pages.Order.Create.CodiceRiserva')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.palletId"
                          :label="$t('pages.Order.Create.PalletId')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="save()"
                    class="white--text styleButtonTop"
                    style="margin-left: 0px; margin-right: 16px;"
                    color="#279947"
                  >
                    <v-icon left>check_circle</v-icon>
                    {{ $t("pages.Order.Create.Salva") }}
                  </v-btn>
                  <v-btn
                    class="styleButtonTop"
                    style="margin-left: 0px"
                    @click="close()"
                  >
                    <v-icon left>remove_circle</v-icon>
                    {{ $t("pages.Order.Create.Annulla") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-data-table
            style="border-top: 10px"
            :headers="getHeaders"
            :items="dataTables"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.articleCode }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.qta }}</td>
              <td>{{ props.item.site }}</td>
              <td>{{ props.item.reserveCode }}</td>
              <td>{{ props.item.palletId }}</td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
            <!-- <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>-->
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>
    <!--bottoni-->
    <v-layout>
      <v-flex xs12 sm12>
        <v-btn
          @click="openSaveDialog()"
          class="white--text styleButtonTop"
          style="margin-left: 0px"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.Order.Create.InviaOrdine") }}
        </v-btn>
        <v-btn class="styleButtonTop" style="margin-left: 0px" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.Order.Create.Annulla") }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="insertDialog" persistent max-width="400">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title class="headline">{{ $t("pages.Order.Create.InserimentoOrdine") }}</v-card-title>
        <v-card-text>
          {{ $t("pages.Order.Create.ConfermaInserimentoOrdine") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              insertDialog = false;
              submit();
            "
            class="white--text"
            style="margin-left: 0px; margin-right: 16px;"
            color="#279947"
          >
            <v-icon left>check_circle</v-icon>Ok
          </v-btn>

          <v-btn
            class="styleButtonTop"
            style="margin-left: 0px"
            @click="insertDialog = false"
          >
            <v-icon left>remove_circle</v-icon>
            {{ $t("pages.Order.Create.Annulla") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confermDialog" persistent max-width="400">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title class="headline">{{ $t("pages.Order.Create.ConfermaOrdineTitle") }}</v-card-title>
        <v-card-text>
          {{ $t("pages.Order.Create.ConfermaOrdine") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="CloseConfermDialog()"
            class="white--text"
            style="margin-left: 0px; margin-right: 16px;"
            color="#279947"
          >
            <v-icon left>check_circle</v-icon>Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert :value="errorAlert" type="error" transition="scale-transition">{{
      errorMessage
    }}</v-alert>
  </div>
</template>

<script>
//import Vue from 'vue'

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import router from "@/router/index.js";
import debounce from "debounce";
import insertOrderApi from "../../apiSmartLogistics/InsertOrderApi.js";
import customerComponent from "../../Components/CustomersComponent.vue";

import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    //data of first column
    orderNumber: { required },
    destinationCompanyName: { required },
    destinationAddress: { required },
    destinationCAP: { required },
    destinationLocation: { required },
    destinationProvince: { required },
    //data of second columm
    customer: { required },
    //data of third columm
    newCodeCustomer: { required },
    newBusinessNameCustomer: { required },
    newClientAddress: { required },
    newClientCAP: { required },
    newClientPlace: { required },
    newClientProvince: { required },
    newClientNation: { required },
    articleCode: { required },
    qta: { required }
  },

  components: { customerComponent },

  //new table data
  data: () => ({
    errorAlert: false,
    errorMessage: "",
    dialog: false,
    insertDialog: false,
    confermDialog: false,

    dataTables: [],
    editedIndex: -1,
    editedItem: {
      articleCode: "",
      description: "",
      qta: "",
      site: "",
      reserveCode: "",
      palletId: ""
    },
    defaultItem: {
      articleCode: "",
      description: "",
      qta: "",
      site: "",
      reserveCode: "",
      palletId: ""
    },
    //end

    modal: false,
    modal2: false,
    //Dati righe ordine
    headers: [],
    //articlesCodes: [],
    //articlesDescriptions: [],
    //dataOrderRows: [{ articleCode: "", description: "", site: "",
    //reserveCode: "", palletId: "", qta: 0 }],

    articleCode: "",
    articles: [],
    description: "",
    descriptions: [],
    site: "",
    reserveCode: "",
    palletId: "",
    qta: "",

    //data of first column
    orderNumber: "",
    refOrderClient: "",
    dateClientOrder: "",
    deliveryDate: "",
    destinationCompanyName: "",
    destinationAddress: "",
    destinationCAP: "",
    destinationLocation: "",
    destinationProvince: "",
    destiationNation: "",
    nations: [],
    orderType: "",
    orders: [],
    mark: "0,000",
    port: "",
    ports: [],
    causalTrasnport: "",
    casuals: [],
    carrier: "",
    carriers: [],
    clientEmail: "",
    note: "",
    //data of second column
    customer: "",
    customers: [],
    codeCustomer: "",
    businessNameCustomer: "",
    clientAddress: "",
    clientCAP: "",
    clientPlace: "",
    clientProvince: "",
    clientNation: "",
    //nations: [],
    client: "",
    //data of third column
    newCodeCustomer: "",
    newBusinessNameCustomer: "",
    newClientAddress: "",
    newClientCAP: "",
    newClientPlace: "",
    newClientProvince: "",
    newClientNation: "",
    Newnations: [],
    //data for btn create
    addUser: false,
    btnAddUser: true,
    btnCancelAddUser: false,
    //data of "usa dati anagrafica"
    useData: false,
    newUseData: false,

    rules: {
      // required: value => !!value || "Il campo non può essere vuoto",
      // counter: value => value.length <= 20 || "Max 20 characters",
      digits: value => {
        const pattern = /^[0-9]*$/;
        return (
          pattern.test(value) ||
          this.currentLanguage.t("Validations.QtaMaggiore0")
        );
      },
      decimal: value => {
        const pattern = /^(\d{1,4}|\d{1,4},\d{1,3})$/;
        return (
          pattern.test(value) ||
          this.currentLanguage.t("Validations.FormatoRichiesto")
        );
      },
      max12: value => {
        return (value.length <= 12 ||
        Trans.i18n.t("pages.Item.Create.Massimo12"))
      },
      max50: value => {
        return (value.length <= 50 ||
        Trans.i18n.t("pages.Item.Create.Massimo50"))
      },
      max10: value => {
        return (value.length <= 10 ||
        Trans.i18n.t("pages.Item.Create.Massimo10"))
      },
      max2: value => {
        return (value.length <= 2 ||
        Trans.i18n.t("pages.Item.Create.Massimo2"))
      }
    },
    varAppoggio: {}
  }),
  mounted() {
    
  },
  // created(){
  //   this.initialize()
  // },
  computed: {
     getHeaders() {
       let headers = [
      {
        text: this.currentLanguage.t("pages.Order.Create.CodiceArticolo"),
        align: "left",
        sortable: false,
        value: "articleCode"
      },
      {
        text: this.currentLanguage.t("pages.Order.Create.Descrizione"),
        align: "left",
        sortable: false,
        value: "description"
      },
      {
        text: this.currentLanguage.t("pages.Order.Create.Qta"),
        align: "left",
        sortable: false,
        value: "qta"
      },
      {
        text: this.currentLanguage.t("pages.Order.Create.Lotto"),
        align: "left",
        sortable: false,
        value: "site"
      },
      {
        text: this.currentLanguage.t("pages.Order.Create.CodiceRiserva"),
        align: "left",
        sortable: false,
        value: "reserveCode"
      },
      {
        text: this.currentLanguage.t("pages.Order.Create.PalletId"),
        align: "left",
        sortable: false,
        value: "palletId"
      },
      { text: "", sortable: false }
    ];
      return headers;
     },

    formTitle() {
      if (this.editedIndex === -1) {
        this.clearEditItem();
        this.$v.$reset();
        return this.currentLanguage.t("pages.Order.Create.NuovoOrdine");
      } else {
        return this.currentLanguage.t("pages.Order.Create.ModificaOrdine");
      }
      //return this.editedIndex === -1 ? 'Nuovo ordine': 'Modifica ordine'
    },
    edit() {
      return true;
    },
    //first column errors:
    orderNumberErrors() {
      const errors = [];
      if (!this.$v.orderNumber.$dirty) return errors;
      !this.$v.orderNumber.required &&
        errors.push(this.currentLanguage.t("Validations.InserireNumeroOrdine"));
      return errors;
    },
    destinationCompanyNameErrors() {
      const errors = [];
      if (!this.$v.destinationCompanyName.$dirty) return errors;
      !this.$v.destinationCompanyName.required &&
        errors.push(this.currentLanguage.t("Validations.InserireRagSocDest"));
      return errors;
    },
    destinationAddressErrors() {
      const errors = [];
      if (!this.$v.destinationAddress.$dirty) return errors;
      !this.$v.destinationAddress.required &&
        errors.push(
          this.currentLanguage.t("Validations.InserireIndirizzoDest")
        );
      return errors;
    },
    destinationCAPErrors() {
      const errors = [];
      if (!this.$v.destinationCAP.$dirty) return errors;
      !this.$v.destinationCAP.required &&
        errors.push(this.currentLanguage.t("Validations.InserireCapDest"));
      return errors;
    },
    destinationLocationErrors() {
      const errors = [];
      if (!this.$v.destinationLocation.$dirty) return errors;
      !this.$v.destinationLocation.required &&
        errors.push(this.currentLanguage.t("Validations.InserireLocalitaDest"));
      return errors;
    },
    destinationProvinceErrors() {
      const errors = [];
      if (!this.$v.destinationProvince.$dirty) return errors;
      !this.$v.destinationProvince.required &&
        errors.push(this.currentLanguage.t("Validations.InserireProvDest"));
      return errors;
    },

    //second column errors:
    ClientError() {
      const errors = [];
      if (!this.$v.client.$dirty) return errors;
      !this.$v.client.required &&
        errors.push(this.currentLanguage.t("Validations.Richiesto"));
      return errors;
    },
    CustomerError() {
      const errors = [];
      if (!this.$v.customer.$dirty) return errors;
      !this.$v.customer.required && this.addUser == false &&
        errors.push(this.currentLanguage.t("Validations.InserireCliente"));
      return errors;
    },
    //third column errors:
    newCodeCustomerError() {
      const errors = [];
      if (!this.$v.newCodeCustomer.$dirty) return errors;
      !this.$v.newCodeCustomer.required &&
        errors.push(this.currentLanguage.t("Validations.CodiceCliente"));
      return errors;
    },
    newBusinessNameCustomerError() {
      const errors = [];
      if (!this.$v.newBusinessNameCustomer.$dirty) return errors;
      !this.$v.newBusinessNameCustomer.required &&
        errors.push(this.currentLanguage.t("Validations.InserireRagSoc"));
      return errors;
    },
    newClientAddressError() {
      const errors = [];
      if (!this.$v.newClientAddress.$dirty) return errors;
      !this.$v.newClientAddress.required &&
        errors.push(this.currentLanguage.t("Validations.InserireIndirizzo"));
      return errors;
    },
    newClientCAPError() {
      const errors = [];
      if (!this.$v.newClientCAP.$dirty) return errors;
      !this.$v.newClientCAP.required &&
        errors.push(this.currentLanguage.t("Validations.InserireCap"));
      return errors;
    },
    newClientPlaceError() {
      const errors = [];
      if (!this.$v.newClientPlace.$dirty) return errors;
      !this.$v.newClientPlace.required &&
        errors.push(this.currentLanguage.t("Validations.InserireLocalita"));
      return errors;
    },
    newClientProvinceError() {
      const errors = [];
      if (!this.$v.newClientProvince.$dirty) return errors;
      !this.$v.newClientProvince.required &&
        errors.push(this.currentLanguage.t("Validations.InserireProv"));
      return errors;
    },
    newClientNationError() {
      const errors = [];
      if (!this.$v.newClientNation.$dirty) return errors;
      !this.$v.newClientNation.required &&
        errors.push(this.currentLanguage.t("Validations.InserireProv"));
      return errors;
    },

    qtaError() {
      const errors = [];
      if (!this.$v.qta.$dirty) return errors;
      !this.$v.qta.required &&
        errors.push(this.currentLanguage.t("Validations.InserireQuantità"));
      return errors;
    },

    articleCodeError() {
      const errors = [];
      if (!this.$v.articleCode.$dirty) return errors;
      !this.$v.articleCode.required &&
        errors.push(this.currentLanguage.t("Validations.InserireCodArt"));
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    back() {
      router.push("/");
    },

    OnChangeClient: debounce(function(event) {
    if (event.target.value.length > 2) {
        let searchItem = {
          searchKey: event.target.value,
          id: this.customerSelected,
        };

        insertOrderApi.GetClientsSearch(searchItem).then(({ data }) => {
          this.customers = data;
          event.target.value = data;
        });
      }
    }, 200),

    //new methods table
    editItem(item) {
      this.editedIndex = this.dataTables.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.qta = this.editedItem.qta;
      this.articleCode = this.editedItem.articleCode;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.dataTables.indexOf(item);
      //confirm("Sei sicuro di voler eliminare l'ordine?") &&
      this.dataTables.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    clearEditItem() {
      this.qta = 0;
      this.articleCode = "";
    },

    save() {
      this.$v.$touch();

      if (this.qta && this.articleCode) {
        if (this.editedIndex > -1) {
          this.editedItem.qta =  this.qta;
         this.editedItem.articleCode =  this.articleCode ;
            
          let c = this.articles.find(
            x => x.codart == this.editedItem.articleCode
          );
          this.editedItem.description = c.descr;
          Object.assign(this.dataTables[this.editedIndex], this.editedItem);
          this.clearEditItem();
        } else {
          this.editedItem.qta =  this.qta;
          this.editedItem.articleCode =  this.articleCode ;
          this.dataTables.push(this.editedItem);
          let b = this.articles.find(
            x => x.codart == this.editedItem.articleCode
          );
          this.editedItem.description = b.descr;
          this.clearEditItem();
        }
        this.close();
      }
    },

    //end

    // refreshAndNewUser(tmp){
    //   viewCreate(tmp);
    //   //location.reload();
    // },

    viewCreate(selection) {
      this.addUser = selection;
      this.btnAddUser = false;
      this.btnCancelAddUser = true;
    },
    hideCreate(selection) {
      this.addUser = selection;
      this.btnAddUser = true;
      this.btnCancelAddUser = false;
    },

    autocompleteClient(param) {
      if (param == true) {
        this.compileClient();
      } else {
        this.clearClient();
      }
    },

    compileClient() {
      this.destinationAddress = this.clientAddress;
      this.destinationCAP = this.clientCAP;
      this.destinationLocation = this.clientPlace;
      this.destinationProvince = this.clientProvince;
      this.destiationNation = this.clientNation;
      this.destinationCompanyName = this.businessNameCustomer;
    },

    clearClient() {
      this.destinationCompanyName = "";
      this.destinationAddress = "";
      this.destinationCAP = "";
      this.destinationLocation = "";
      this.destinationProvince = "";
      this.destiationNation = "";
    },

    autocompleteNewClient(param) {
      if (param == true) {
        this.compileNewClient();
      } else {
        this.clearNewClient();
      }
    },

    compileNewClient() {
      this.destinationCompanyName = this.newBusinessNameCustomer;
      this.destinationAddress = this.newClientAddress;
      this.destinationCAP = this.newClientCAP;
      this.destinationLocation = this.newClientPlace;
      this.destinationProvince = this.newClientProvince;
      this.destiationNation = this.newClientNation;
    },
    
    clearNewClient() {
      this.destinationCompanyName = "";
      this.destinationAddress = "";
      this.destinationCAP = "";
      this.destinationLocation = "";
      this.destinationProvince = "";
      this.destiationNation = "";
    },

    clearNewCommittente() {
      this.customer = "";
      this.customers = [];

      this.codeCustomer = "";
      this.businessNameCustomer = "";
      this.clientAddress = "";
      this.clientCAP = "";
      this.clientPlace = "";
      this.clientProvince = "";
      this.clientNation = "";
    },

    custChanged(customerSelected) {
      this.customerSelected = customerSelected;

      // insertOrderApi.GetClients(customerSelected).then(({ data }) => {
      //   this.customers = data;
      // });

      this.clearNewCommittente()

      insertOrderApi.GetNations(customerSelected).then(({ data }) => {
        this.nations = data;
        this.Newnations = data;
      });

      insertOrderApi.GetTypeOrder(customerSelected).then(({ data }) => {
     
        this.orders = data;      
        if (this.orders.length > 0) {
          this.orderType = this.orders[0].tipoordine;
        }
      });

      insertOrderApi.GetPort(customerSelected).then(({ data }) => {
        this.ports = data;
      });

      insertOrderApi.GetTransportCasual(customerSelected).then(({ data }) => {
        this.casuals = data;
      });

      insertOrderApi.GetCarrier(customerSelected).then(({ data }) => {
        this.carriers = data;
        if (this.carriers.length > 0) {
          var x = this.carriers.filter(x => x.codvettore == "ND")[0]; //x = this.carriers.filter(x => x.codvettore == "N")[0]; > N or ND == non definito

          if(x)
          {
            this.carrier = x.codvettore;
          }
        }
      });

      insertOrderApi.GetArticle(customerSelected).then(({ data }) => {
        this.articles = data;
      });
    },

    checkAutoFill() {
      if (this.customer != "") {
        this.autofill();
      }
    },

    autofill() {
      var custom = this.customer;
      var codeCustome;
      var businessNameCustome;
      var clientAddres;
      var clientCA;
      var clientPlac;
      var clientProvinc;
      var clientNatio;

      this.customers.filter(function(ele) {
        if (ele.codcli == custom) {
          codeCustome = ele.codcli;
          businessNameCustome = ele.ragsoc;
          clientAddres = ele.indirizzo;
          clientCA = ele.cap;
          clientPlac = ele.localita;
          clientProvinc = ele.provincia;
          clientNatio = ele.nazione;
        }
      });

      this.codeCustomer = codeCustome;
      this.businessNameCustomer = businessNameCustome;
      this.clientAddress = clientAddres;
      this.clientCAP = clientCA;
      this.clientPlace = clientPlac;
      this.clientProvince = clientProvinc;
      this.clientNation = clientNatio;
    },

    openSaveDialog() {
      this.$v.$touch();
      if (
        this.$v.destinationCompanyName.$error ||
        this.$v.destinationAddress.$error ||
        this.$v.destinationLocation.$error ||
        this.$v.destinationProvince.$error ||
        this.$v.destinationCAP.$error ||
        (this.$v.customer.$error && this.addUser == false)
      ) {
        this.$refs.customerComponent.validate();
        
        return;
      } else if (this.addUser == true) {
        if (
          this.$v.newCodeCustomer.$error ||
          this.$v.newBusinessNameCustomer.$error ||
          this.$v.newClientAddress.$error ||
          this.$v.newClientCAP.$error ||
          this.$v.newClientPlace.$error ||
          this.$v.newClientProvince.$error
        ) {
          this.$refs.customerComponent.validate();          
          return;
        } else {
          this.insertDialog = true;
        }
      } else {
        this.insertDialog = true;
      }
    },

    CloseConfermDialog(){
      this.confermDialog = false;
      router.push("/");
    },

    submit() {

      let article = {
        customerSelected: this.customerSelected,
        codeCustomer: this.codeCustomer,
        //codcli
        orderNumber: this.orderNumber,
        refOrderClient: this.refOrderClient,
        dateClientOrder: this.dateClientOrder,
        deliveryDate: this.deliveryDate,
        destinationCompanyName: this.destinationCompanyName,
        destinationCompanyAddress: this.destinationAddress,
        destinationLocation: this.destinationLocation,
        destinationProvince: this.destinationProvince,
        destinationCAP:this.destinationCAP,
        destinationNation: this.destiationNation,
        orderType: this.orderType,
        //orderType: this.orderNumber,
        codart: this.dataTables,
        mark: this.mark,
        port: this.port,
        causalTrasnport: this.causalTrasnport,
        carrier: this.carrier,
        clientEmail: this.clientEmail,
        note: this.note,
        articleCode: this.articleCode,
        description: this.description,
        qta: this.qta,
        site: this.site,
        reserveCode: this.reserveCode,
        palletId: this.palletId,
        customer: this.customer,
        newCodeCustomer: this.newCodeCustomer,
        newClientAddress: this.newClientAddress,
        newClientCAP: this.newClientCAP,
        newClientNation: this.newClientNation,
        newClientPlace: this.newClientPlace,
        newBusinessNameCustomer: this.newBusinessNameCustomer
      };

      insertOrderApi
        .InsertOrder(article)
        .then(() => {
          this.insertDialog = false;
          this.confermDialog = true;
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMessage = error.response.data;
        });
    },

    clear() {
      this.$v.$reset();

      this.$refs.customerComponent.clear();
      this.orderNumber = "";
      this.refOrderClient = "";
      this.dateClientOrder = "";
      this.deliveryDate = "";

      (this.articleCode = ""),
        (this.description = ""),
        (this.site = ""),
        (this.reserveCode = ""),
        (this.palletId = ""),
        (this.qta = 0),
        (this.destinationCompanyName = "");
      this.destinationAddress = "";
      this.destinationCAP = "";
      this.destinationLocation = "";
      this.destinationProvince = "";
      this.destinationNation = "";
      this.orderType = "";
      this.mark = "0,000";
      this.port = "";
      this.causalTrasnport = "";
      this.carrier = "";
      this.clientEmail = "";
      this.note = "";
      this.nations = "";
      //second column
      this.customer = "";
      this.codeCustomer = "";
      this.businessNameCustomer = "";
      this.clientAddress = "";
      this.clientCAP = "";
      this.clientPlace = "";
      this.clientNation = "";
      this.client = "";
      this.clientProvince = "";
      //third column
      (this.newCodeCustomer = ""),
        (this.newBusinessNameCustomer = ""),
        (this.newClientAddress = ""),
        (this.newClientCAP = ""),
        (this.newClientPlace = ""),
        (this.newClientProvince = ""),
        (this.newClientNation = ""),
        (this.Newnations = []);
    }
  }
};
</script>
